import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, browserHistory } from 'react-router';
import _ from 'lodash';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import { showModal, hideModal } from '../../../../actions/ModalActions';
// import { editEvent } from '../../../../actions/website/entities/EventActions';
import { getRsvpPageEvents, editEvent } from '../../../../actions/website/entities/RsvpActions';
import { fetchGuestList } from '../../../../actions/GuestActions';
import { moveEntity, resetEntities, addEntity, deleteEntityV2 } from '../../../../actions/website/EntityActions';
import { getEventType } from './EventTypes'; // eslint-disable-line
import EntityHeader from './EntityHeader';
import DragHandle from '../../../common/ui/DragHandle';
import { togglePage } from '../../../../actions/website/PageActions';
import Tag from '../../common/Tag/Tag';


const Rsvp = SortableElement(({ rsvp, onEdit, onDelete }) => { // eslint-disable-line
  const noPropagate = (e) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
  };
  const numGuestsInvited = rsvp.num_guests_attending + rsvp.num_guests_declined + rsvp.num_guests_not_responded;
  const trimmedRsvpName = rsvp.name.length > 30 ? `${rsvp.name.slice(0, 30)}...` : rsvp.name;
  return (
    <li className="sortable-item editable-entity" onClick={() => onEdit(rsvp)}>
      <div className="col-sm-1">
        <DragHandle tooltip="Drag to reorder" />
      </div>
      <div className="col-sm-10 event-info">
        <span className="">
          <span className="event-title">{trimmedRsvpName}</span>
          <span className="event-visibility">
            {rsvp.collect_rsvps ? (
              <Tag className="tag-primary">
                Online RSVP Enabled
              </Tag>
            ) : (
              <Tag className="tag-secondary">
                Online RSVP Disabled
              </Tag>
            )}
          </span>
        </span>
        <p className="description">
          <Link to="/wedding/manage/guests/build" className="text-primary" onClick={noPropagate}>
            {numGuestsInvited} {numGuestsInvited === 1 ? 'guest' : 'guests'} invited
          </Link>
        </p>
      </div>
      <div className="col-sm-1 entity-actions" onClick={noPropagate}>
        <button onClick={() => onEdit(rsvp)} title="Edit event" className="btn btn-icon with-tooltip no-tooltip-on-mobile" data-tooltip="Edit"><i className="glyphicon glyphicon-pencil" /></button>
      </div>
    </li>
  );
});

Rsvp.propTypes = {
  rsvp: PropTypes.shape({}).isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  index: PropTypes.number
};


class Rsvps extends Component {
  constructor(props) {
    super(props);

    this.handlePageToggle = this.handlePageToggle.bind(this);
  }

  componentDidMount() {
    const { getRsvpEntities, getGuestList } = this.props;
    getRsvpEntities();
    getGuestList();
  }

  componentWillUnmount() {
    const { unloadEntities } = this.props;
    unloadEntities();
  }

  handlePageToggle(pageId) {
    const { page, guests, rsvpEntities, orderedIds, onPageToggle, showErrorModal, showSuccessModal } = this.props;

    const numGuestsInvited = _.reduce(guests.orderedIds, (sum, guestGroupId) => {
      const guestGroup = guests.byId[guestGroupId];
      const eventInvitations = _.flatMap(guestGroup.guests, guest => guest.event_invitations);
      return sum + eventInvitations.length;
    }, 0);
    // console.log(numGuestsInvited);

    const noEvents = orderedIds.length === 0;
    const noGuests = _.isEmpty(guests.byId);
    const noGuestsInvited = numGuestsInvited === 0;
    const rsvpDisabled = orderedIds.filter(id => rsvpEntities[id].collect_rsvps === true).length === 0;

    if (!page.hidden) {
      onPageToggle(pageId);
    } else if (noEvents) {
      const errorModalProps = {
        heading: 'Want guests to RSVP on your wedding website?',
        body: 'First, create an event and build a guest list for it. Then you\'ll be able to unhide this page and let guests RSVP on this page',
        button: {
          text: 'Create An Event',
          action: () => browserHistory.push('/wedding/manage/events')
        }
      };
      showErrorModal(errorModalProps);
    } else if (noGuests) {
      const errorModalProps = {
        heading: 'Want guests to start using this page?',
        body: 'First, build your Guest Directory.',
        button: {
          text: 'Go To Guest Directory',
          action: () => browserHistory.push('/wedding/manage/guests/all')
        }
      };
      showErrorModal(errorModalProps);
    } else if (noGuestsInvited) {
      const errorModalProps = {
        heading: 'Want guests to start using this page?',
        body: 'First, choose some to invite.',
        button: {
          text: 'Invite Guests',
          action: () => browserHistory.push('/wedding/manage/guests/build')
        }
      };
      showErrorModal(errorModalProps);
    } else if (rsvpDisabled) {
      const errorModalProps = {
        heading: 'Want guests to start using this page?',
        body: 'Turn on online RSVPs for at least one of your events (and make sure guests have already been invited).',
      };
      showErrorModal(errorModalProps);
    } else {
      onPageToggle(pageId);
      showSuccessModal();
    }
  }

  render() {
    const { rsvpEntities, orderedIds, openModal, onEdit, onDelete, page, themeKey } = this.props;

    return (
      <div>
        {themeKey && (
          <EntityHeader
            onAdd={openModal}
            entityName="Event"
            page={page}
            themeKey={themeKey}
            onPageToggle={this.handlePageToggle}
          />
        )}
        <ul className="sortable-list">
          {rsvpEntities && orderedIds.map((eventId, index) => (
            <Rsvp
              key={index}
              onDelete={onDelete}
              onEdit={onEdit}
              rsvp={rsvpEntities[eventId]}
              index={index}
            />
          ))}
        </ul>
      </div>
    );
  }
}

Rsvps.propTypes = {
  rsvpEntities: PropTypes.shape({}),
  orderedIds: PropTypes.arrayOf(PropTypes.number),
  getRsvpEntities: PropTypes.func.isRequired,
  guests: PropTypes.shape({}),
  getGuestList: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  unloadEntities: PropTypes.func.isRequired,
  page: PropTypes.shape({}),
  themeKey: PropTypes.string,
  onPageToggle: PropTypes.func,
  showSuccessModal: PropTypes.func,
  showErrorModal: PropTypes.func,
};

const mapStateToProps = state => ({
  rsvpEntities: state.website.entities.byId,
  orderedIds: state.website.entities.orderedIds,
  page: state.website.pages.byId[state.website.pages.typeToId.RSVP],
  themeKey: state.wedding.theme.key,
  guests: state.guestList.guests,
});

const mapDispatchToProps = dispatch => ({
  onSortEnd: ({ oldIndex, newIndex }) => dispatch(moveEntity(oldIndex, newIndex)),
  openModal: () => {
    dispatch(addEntity());
    dispatch(showModal('WEBSITE_EVENT_FORM', { collectRsvps: true }, { size: 'md' }));
  },
  getRsvpEntities: () => dispatch(getRsvpPageEvents()),
  getGuestList: () => dispatch(fetchGuestList()),
  onEdit: (rsvp) => {
    dispatch(editEvent(rsvp));
    dispatch(showModal('WEBSITE_EVENT_FORM', {}, { size: 'md' }));
  },
  onDelete: (rsvp) => {
    const onDeleteEvent = () => {
      dispatch(deleteEntityV2(rsvp)).then(() => {
        dispatch(hideModal());
      });
    };
    dispatch(showModal('DELETE_EVENT', { event: rsvp, onDeleteEvent }, { size: 'md' }));
  },
  unloadEntities: () => dispatch(resetEntities()),
  onPageToggle: pageId => dispatch(togglePage(pageId)),
  showSuccessModal: () => dispatch(showModal('PUBLISH_RSVP', {}, { size: 'md' })),
  showErrorModal: errorModalProps => dispatch(showModal('PUBLISH_PAGE_ERROR', { ...errorModalProps }, { size: 'md' })),
});

const SortableRsvps = SortableContainer(Rsvps);

const RsvpsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SortableRsvps);

export default RsvpsContainer;



/** WEBPACK FOOTER **
 ** ./src/components/manage/website/entities/RsvpV2.jsx
 **/